import { render, staticRenderFns } from "./EditInfectionSite.vue?vue&type=template&id=b7e96990&"
import script from "./EditInfectionSite.vue?vue&type=script&lang=js&"
export * from "./EditInfectionSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports